import React from 'react';

function Footer() {
  return (
    <footer>
      <span>Copyright &copy; 2023. All rights reserved.</span>
    </footer>
  );
}

export default Footer;
